// extracted by mini-css-extract-plugin
export var createdDate = "_nj-1";
export var divider = "_nj-2";
export var headerDivider = "_nj-3";
export var messagesCard = "_nj-0";
export var messagesContainer = "_nj-6";
export var messagesContainerWrapper = "_nj-4";
export var showLeftPanelButton = "_nj-8";
export var topButtons = "_nj-7";
export var withPadding = "_nj-5";